import clsx from 'clsx';
import React from 'react';

import { ColorScheme } from '~/design-tokens/themes/themes';
import { getBasePath } from '~/utils/base-path/basePath';

import styles from './Loading.module.scss';

interface LoadingProps {
  className?: string;
  colorScheme?: ColorScheme;
  basePath?: string;
}

export const Loading = ({
  className,
  colorScheme = ColorScheme.Dark,
  basePath = getBasePath(),
}: LoadingProps) => (
  <div className={clsx(styles.loader, className)} data-testid="loading-view">
    <div className={styles.innerBox}>
      <div className={styles.logoBox}>
        <img
          data-testid="loading-logo"
          src={`${basePath}/static/images/brand/logo-${colorScheme}.svg`}
          alt="logo"
        />
      </div>
      <div className={styles.progressBar}>
        <div className={styles.progressBarMeter} />
      </div>
    </div>
  </div>
);
